import { http } from '@/api/http'

// Управление пользователями системы — только для админов (is_staff / is_superuser).
// Бэкенд: /api/users/admin/

export function listAdminUsers(params = {}) {
    return http.get('users/admin/', { params }).then(r => r.data.results || r.data)
}

export function getAdminUser(id) {
    return http.get(`users/admin/${id}/`).then(r => r.data)
}

export function createAdminUser(payload) {
    return http.post('users/admin/', payload).then(r => r.data)
}

export function updateAdminUser(id, payload) {
    return http.patch(`users/admin/${id}/`, payload).then(r => r.data)
}

export function deleteAdminUser(id) {
    return http.delete(`users/admin/${id}/`).then(r => r.data)
}
